import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./node_modules/@blue-x/font-icons/css/font-icons.css";

ReactDOM.render(<App />, document.getElementById("root"));
